// extracted by mini-css-extract-plugin
export var container = "ourValues-module--container--inTXO";
export var background = "ourValues-module--background--qKMR7";
export var blocTitle = "ourValues-module--blocTitle--K-baS";
export var blocText = "ourValues-module--blocText--xkQW0";
export var containerResponsive = "ourValues-module--containerResponsive--rhEdC";
export var singleValueContainer = "ourValues-module--singleValueContainer--jaM-R";
export var singleValueTitle = "ourValues-module--singleValueTitle--AeE4z";
export var singleValueText = "ourValues-module--singleValueText--wa2b5";
export var singleValueImage = "ourValues-module--singleValueImage--PtGel";